export const ACCORDION_STYLE = {
	border: "none",
	borderRadius: 0,
	borderBottom: "2px solid #ff5733",
	"&.MuiAccordion-root": {
		backgroundColor: "transparent",
		"&:last-of-type": {
			borderBottomRightRadius: 0,
			borderBottomLeftRadius: 0,
		},
		"&:first-of-type": {
			borderTopRightRadius: 0,
			borderTopLeftRadius: 0,
		},
	},
	"&.Mui-expanded": {
		borderBottom: 0,
		minHeight: "48px",
	},
};

export const ACCORDION_SUMMARY_STYLE = {
	"&.Mui-expanded": {
		borderBottom: "2px solid rgba(255, 87, 51, 0.3)",
		minHeight: "48px",
	},
};

export const ACCORDION_DETAILS_STYLE = {
	backgroundColor: "#FFFFFF",
	paddingBottom: 0,
	paddingTop: 0,
};

export const ACCORDION_CHECKBOX_STYLE = {
	svg: {
		"&.MuiSvgIcon-root": {
			fill: "#ff5733",
			backgroundColor: "transparent",
			color: "#ffffff",
		},
	},
};
